import React from 'react';

const LakeStation = React.memo(({ location, name, temperature }) => {
  // Funktion um Temperaturkategorie zu bestimmen
  const getTemperatureCategory = (temp) => {
    if (temp === null || temp === undefined) return 'unknown';
    if (temp < 10) return 'cold';
    if (temp < 20) return 'moderate';
    if (temp < 25) return 'warm';
    return 'hot';
  };

  // Funktion um Temperatur-Emoji zu bekommen
  const getTemperatureEmoji = (temp) => {
    if (temp === null || temp === undefined) return '❓';
    if (temp < 5) return '🧊';
    if (temp < 10) return '❄️';
    if (temp < 15) return '🌀';
    if (temp < 20) return '💧';
    if (temp < 25) return '🌊';
    return '🔥';
  };

  // Funktion um passende Aktivität vorzuschlagen
  const getActivitySuggestion = (temp) => {
    if (temp === null || temp === undefined) return 'Daten nicht verfügbar';
    if (temp < 10) return 'Nur für Eisbären geeignet! 🐻‍❄️';
    if (temp < 15) return 'Perfekt zum Aufwachen! ⚡';
    if (temp < 20) return 'Erfrischend für Mutige 💪';
    if (temp < 25) return 'Ideal zum Schwimmen! 🏊‍♀️';
    return 'Badespass pur! ☀️';
  };

  const tempCategory = getTemperatureCategory(temperature);
  const tempEmoji = getTemperatureEmoji(temperature);
  const activitySuggestion = getActivitySuggestion(temperature);

  return (
    <div className="station-card">
      <h2>{location}</h2>
      <div className="station-info">
        <div className="info-row">
          <span className="info-icon">🏞️</span>
          <span className="info-label">Gewässer:</span>
          <span className="info-value">{name}</span>
        </div>
        
        <div className="info-row">
          <span className="info-icon">{tempEmoji}</span>
          <span className="info-label">Temperatur:</span>
          <span className={`info-value temperature-display ${tempCategory !== 'unknown' ? `temperature-${tempCategory}` : ''}`}>
            {temperature !== null && temperature !== undefined 
              ? `${temperature.toFixed(1)}°C` 
              : 'Keine Daten'}
          </span>
        </div>

        <div className="info-row">
          <span className="info-icon">💭</span>
          <span className="info-label">Einschätzung:</span>
          <span className="info-value" style={{ fontSize: '0.9rem', fontStyle: 'italic' }}>
            {activitySuggestion}
          </span>
        </div>
      </div>
    </div>
  );
});

LakeStation.displayName = 'LakeStation';

export default LakeStation;
